import {Button} from '@common/ui/buttons/button';
import {useTrans} from '@common/i18n/use-trans';
import {message} from '@common/i18n/message';
import {useState} from 'react';
import {Trans} from '@common/i18n/trans';
import {useNavigate} from '@common/utils/hooks/use-navigate';
import {useAuth} from '@common/auth/use-auth';
import {setInLocalStorage} from '@common/utils/hooks/local-storage';
import {toast} from '@common/ui/toast/toast';
import {useSettings} from '@common/core/settings/use-settings';
import {useLightThemeVariables} from '@common/ui/themes/use-light-theme-variables';

export const PENDING_BIOLINK_NAME_KEY = 'be.pending_biolink_name';

export function LandingPageNewLinkForm() {
  const {trans} = useTrans();
  const lightThemeVars = useLightThemeVariables();
  const [name, setName] = useState('');
  const navigate = useNavigate();
  const {isLoggedIn} = useAuth();
  const {base_url} = useSettings();

  const siteHost = base_url
    ? base_url.replace(/^https?:\/\//, '').replace(/\/$/, '')
    : window.location.hostname;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) {
      toast.danger(message('Please enter a name for your biolink.'));
      return;
    }
    setInLocalStorage(PENDING_BIOLINK_NAME_KEY, trimmed);
    if (isLoggedIn) {
      navigate('/dashboard/biolinks');
    } else {
      navigate('/register');
    }
  };

  return (
    <form
      className="mt-60 w-full md:mt-80 md:max-w-580 mx-auto"
      onSubmit={handleSubmit}
    >
      <div
        className="flex items-stretch w-full rounded-full overflow-hidden bg-white shadow-lg"
        style={{ ...lightThemeVars, border: '1px solid #1b130d1a' }}
      >
        <div className="flex items-center pl-20 pr-4 shrink-0">
          <span
            className="text-sm font-medium whitespace-nowrap select-none"
            style={{color: 'rgb(100 116 139)'}}
          >
            {siteHost}/
          </span>
        </div>
        <input
          className="flex-1 min-w-0 py-14 pr-8 text-sm bg-transparent outline-none"
          style={{color: 'rgb(30 41 59)', caretColor: 'rgb(30 41 59)'}}
          placeholder={trans(message('name'))}
          value={name}
          onChange={e => setName(e.target.value)}
          autoComplete="off"
          spellCheck={false}
        />
        <div className="p-6 shrink-0">
          <Button
            radius="rounded-full"
            type="submit"
            variant="flat"
            color="primary"
            size="md"
          >
            <Trans message="Start for free" />
          </Button>
        </div>
      </div>
    </form>
  );
}
